(function MarketingTags($, Adzuki)
{
	"use strict";
	var MarketingTags = {};

	MarketingTags.showTagModal = function showTagModal(record_type, record_type_hr, record_id) {
		var $modal = $('.modal');

		Adzuki.Ajax.get('/MarketingTags/tag/' + record_type + '/' + record_id + '/' + record_type_hr)
		.then(function _letsGetEmTagged(content) {

			$modal.find('.modal-title').text("Tag Marketing Item");
			$modal.find('.modal-body').html(content);

			Adzuki.Form.initAjaxForm('MarketingTagItem');

			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');
		});
	};

	$(document).ready(function documentReady()
	{
		$('.marketing-tag').on('click', function _setTag(e) {
			var record_type    = $(this).data('record-type'),
				record_type_hr = $(this).data('record-hr'),
				record_id      = $(this).data('record-id');

			e.preventDefault();

			MarketingTags.showTagModal(record_type, record_type_hr, record_id);
		});

		$('.delete-marketing-tag').on('click', function _checkIfDeleteable(e) {
			var tag_id = $(this).data('id');
			e.preventDefault();

			Adzuki.Ajax.get('/MarketingTags/checkForDeletion/' + tag_id)
			.then(function _letsGetEmTagged(content) {
				if (content.count > 0) {
					Adzuki.CustomConfirm({
						title  : 'Decision Time',
						content: 'This tag is currently tied to (' + content.count + ') Marketing item(s). Deleting this tag will reset the tag for each item. Are you sure you want to delete this marketing tag?',
						confirm: function confirm() {
							document.location = Adzuki.base_uri + '/MarketingTags/delete/' + tag_id;
						}
					});
				} else {
					Adzuki.CustomConfirm({
						title  : 'Decision Time',
						content: 'Are you sure you want to delete this marketing tag?',
						confirm: function confirm() {
							document.location = Adzuki.base_uri + '/MarketingTags/delete/' + tag_id;
						}
					});
				}
			});
		});
	});

	Adzuki.MarketingTags = MarketingTags;

}(jQuery, window.Adzuki || {}));